import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ventaHeroImage } from "@/mocks/serviceVentaData";

export default function ServiceHero() {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative min-h-[420px] md:min-h-[520px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <video
          ref={videoRef}
          src="https://storage.helloreaddy.io/project_files/7ab0d457-3dab-428f-ba9a-e3f3097fe185/a7c6d920-783a-43bd-a5b2-7a178afd5dd4_Crear_video_corporativo_showroom_202609021153.mp4"
          poster={ventaHeroImage}
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay-gradient absolute inset-0" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-28 md:pt-36 pb-12 md:pb-16">
        <div className="max-w-5xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-background-400 mb-8">
            <Link to="/" className="hover:text-background-200 transition-colors whitespace-nowrap">
              Inicio
            </Link>
            <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-background-500" />
            <span className="text-background-200 whitespace-nowrap">Servicios</span>
          </nav>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
            Servicios
          </h1>
        </div>
      </div>
    </section>
  );
}